module.exports = "//static.hsappstatic.net/TemplateAssets/static-1.46/img/hs_kb_template_images/patterns/header_pattern_zigzag_dark.png"